import { Model } from '@/models/Model';
export class Project extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Project';
        this.$endpoint = '/projects';
        this.$fillable = ['name', 'description', 'steps', 'notes', 'files', 'subjects'];
    }
    detachSubjectsFromProject(projectId, subjects) {
        const url = `projects/${projectId}/detach-subjects`;
        const payload = { subjects };
        return this.request('put', url, payload);
    }
}
export var ProjectIncludes;
(function (ProjectIncludes) {
    ProjectIncludes["CHAT"] = "chat";
    ProjectIncludes["SUBJECTS"] = "subjects";
    ProjectIncludes["META"] = "meta";
    ProjectIncludes["LEVEL"] = "level";
    ProjectIncludes["AUDIT"] = "audit";
    ProjectIncludes["USERS"] = "users";
    ProjectIncludes["ROLES"] = "roles";
    ProjectIncludes["PARENT"] = "parent";
    ProjectIncludes["NOTES"] = "notes";
})(ProjectIncludes || (ProjectIncludes = {}));
